import { useDispatch, useSelector } from "react-redux";

import sessionSlice from "../../store/Session/SessionSlice";
import { NormalizedState } from "../../store/Session/helper/NormalizedValues";
import { RootState } from "../../store/store";
import { LmLocation } from "../../models";

import "./style.css";
import NormalizationModal from "../NormalizationModal/NormalizationModal";
import { useState } from "react";

interface Props {
	isNormalized: boolean;
	normalizedState: NormalizedState;
}

const ToggleNormalized = ({
	isNormalized,
	normalizedState,
}: Props): JSX.Element => {
	const dispatch = useDispatch();
	const location = useSelector((state: RootState) => state.session.location);
	const drillTargets = useSelector(
		(state: RootState) => state.session.drillTargets,
	);
	// KWSA-34: Combine sessions get their own normalization message.
	const isCombine = Boolean(drillTargets && drillTargets.length > 0);

	// let toggleState = isNormalized ? "on" : "off";

	const setIsNormalized = () => {
		dispatch(
			sessionSlice.actions.setIsNormalized({
				isNormalized: !isNormalized,
			}),
		);
	};
	const [isModalOpen, setIsModalOpen] = useState(false);

	// KWSA-22: In Simulator mode the normalization toggle is not shown at all.
	if (location === LmLocation.SIMULATOR) {
		return <></>;
	}

	switch (normalizedState) {
		case NormalizedState.alwaysOn:
			return (
				<>
					<div
						className="toggle-normalized-on"
						onClick={() => setIsModalOpen(true)}>
						<img className="knob" alt="" src="/img/fs_knob.svg" />
					</div>
					<NormalizationModal
						isOpen={isModalOpen}
						setIsOpen={setIsModalOpen}
						isNetScreen={true}
						isCombine={isCombine}
					/>
				</>
			);
		case NormalizedState.enabled:
			return (
				<>
					<div
						className={`${
							isNormalized ? "toggle-normalized-on" : "toggle-normalized-off"
						}`}
						onClick={setIsNormalized}>
						<img className="knob" alt="" src="/img/fs_knob.svg" />
					</div>
				</>
			);
		case NormalizedState.notSupported:
		case NormalizedState.disabled:
			return (
				<>
					<div
						className="toggle-normalized-disabled"
						onClick={() => setIsModalOpen(true)}>
						<img className="knob" alt="" src="/img/fs_knob_disabled.svg" />
					</div>
					<NormalizationModal
						isOpen={isModalOpen}
						setIsOpen={setIsModalOpen}
						isNetScreen={false}
						isCombine={isCombine}
					/>
				</>
			);
	}
};

export default ToggleNormalized;
